import React from 'react';
import OrderStatusesWidget from '../../components/Procurement/Widgets/OrderStatusesWidget';
import PendingProductsWidget from '../../components/Procurement/Widgets/PendingProductsWidget';
import { Stack } from '@fluentui/react';
import NeedsApprovalWidget from '../../components/Procurement/Widgets/NeedsApprovalWidget';
import RecentProcurementActivityWidget from '../../components/Procurement/Widgets/RecentProcurementActivityWidget';
import StorefrontProcurementWidget from '../../components/Procurement/Widgets/StorefrontProcurementWidget';
import ProcurementDemandsWidget from '../../components/Procurement/Widgets/ProcurementDemandsWidget';
import ExistingOrderPanel from '../../components/Procurement/Order/ExistingOrderPanel';
import ProcureDemandPanel from '../../components/Procurement/ProcureDemand/ProcureDemandPanel';
import ReSourcePanel from '../../components/Procurement/ReSourcePanel/ReSourcePanel';
import ProcureDemandMultiPanel from '../../components/Procurement/ProcureDemand/ProcureDemandMultiPanel';
import SelectedDisplay from '../../components/Search/SelectedDisplay';
import { useHistory } from 'react-router-dom';
import { PROCUREMENT_ORDER_STATUSES } from '../../Constants';
import StorefrontOrderPanel from '../../components/Storefront/Orders/StorefrontOrderPanel';
import { IProcurementDemandItem } from '../../models/Procurement';

const ProcurementHomePage: React.FC = () => {
    const history = useHistory();
    const [selectedProcurementOrderId, setSelectedProcurementOrderId] = React.useState<string | undefined>(undefined);
    const [selectedStorefrontOrderId, setSelectedStorefrontOrderId] = React.useState<string | undefined>(undefined);
    const [selectedDemandItemId, setSelectedDemandItemId] = React.useState<string | undefined>(undefined);
    const [reSourceMultiple, setReSourceMultiple] = React.useState<string[] | undefined>(undefined);
    const [createOrderDemands, setCreateOrderDemands] = React.useState<IProcurementDemandItem[] | undefined>(undefined);
    const [selectedVendorFilter, setSelectedVendorFilter] = React.useState<string | undefined>(undefined);

    const handleStatusClick = (status: string) => {
        history.push(`/procurement/orders?status=${status}&vendor=${selectedVendorFilter ?? ''}`);
    }
    const handleVendorClick = (vendor: string) => {
        setSelectedVendorFilter(vendor);
    }
    const handleOrderClick = (orderId: string) => {
        setSelectedProcurementOrderId(orderId);
    }
    const handleStorefrontOrderClick = (orderId: string) => {
        setSelectedStorefrontOrderId(orderId);
    }
    const handleDemandItemClick = (itemId: string) => {
        setSelectedDemandItemId(itemId);
    }
    const handleReSourceMultipleClick = (itemIds: string[]) => {
        setReSourceMultiple(itemIds);
    }

    const handleProcuredDemand = (orderId: string) => {
        setSelectedDemandItemId(undefined);
        setSelectedProcurementOrderId(orderId);
    }

    return (
        <div className='main-content'>
            <h1>Procurement</h1>
            <Stack horizontal tokens={{childrenGap: '1em'}} wrap style={{marginBottom: '1em'}}>
                <SelectedDisplay
                    prefix='Vendor'
                    selections={selectedVendorFilter ? [selectedVendorFilter] : []}
                    onChange={(v) => setSelectedVendorFilter(undefined)}
                    />
            </Stack>
            <Stack horizontal tokens={{childrenGap: '1em'}} wrap>
                <OrderStatusesWidget
                    onClickStatus={handleStatusClick}
                    vendorFilter={selectedVendorFilter}
                    />
                <PendingProductsWidget
                    onVendorClick={handleVendorClick}
                    />
                <NeedsApprovalWidget
                    onOrderClick={handleOrderClick}
                    size='medium'
                    vendorFilter={selectedVendorFilter}
                    onFullscreenClick={() => {
                        history.push(`/procurement/orders?status=${PROCUREMENT_ORDER_STATUSES.PENDING}&vendor=${selectedVendorFilter ?? ''}`);
                    }}
                    />
                <ProcurementDemandsWidget
                    onDemandItemClick={handleDemandItemClick}
                    onStorefrontOrderClick={handleStorefrontOrderClick}
                    onReSourceClick={handleReSourceMultipleClick}
                    onCreateOrderClick={setCreateOrderDemands}
                    size='medium'
                    vendorFilter={selectedVendorFilter}
                    onFullscreenClick={() => {
                        history.push(`/procurement/demands/items?vendor=${selectedVendorFilter ?? ''}`);
                    }}
                    />
                <RecentProcurementActivityWidget onOrderClick={handleOrderClick} onDemandItemClick={handleDemandItemClick} size='small' />
                <StorefrontProcurementWidget onStorefrontOrderClick={handleStorefrontOrderClick} onProcurementOrderClick={handleOrderClick} />
            </Stack>
            <ExistingOrderPanel orderId={selectedProcurementOrderId} onClose={() => setSelectedProcurementOrderId(undefined)} />
            {selectedDemandItemId && <ProcureDemandPanel demandId={selectedDemandItemId} onDismiss={() => setSelectedDemandItemId(undefined)} onProcure={handleProcuredDemand} />}
            {reSourceMultiple && (<ReSourcePanel demandIds={reSourceMultiple} onClose={() => setReSourceMultiple(undefined)} onReSourceComplete={() => setReSourceMultiple(undefined)} />)}
            {createOrderDemands && createOrderDemands.length > 0 && (
                <ProcureDemandMultiPanel
                    demands={createOrderDemands}
                    onDismiss={() => setCreateOrderDemands(undefined)}
                    onProcure={(orderId) => {
                        setCreateOrderDemands(undefined);
                        setSelectedProcurementOrderId(orderId);
                    }}
                />
            )}
            {selectedStorefrontOrderId && <StorefrontOrderPanel order={selectedStorefrontOrderId} onDismiss={() => setSelectedStorefrontOrderId(undefined)} />}
        </div>
    );
}

export default ProcurementHomePage;